import { render, staticRenderFns } from "./kw_tab.vue?vue&type=template&id=2c69d953&scoped=true&"
import script from "./kw_tab.vue?vue&type=script&lang=js&"
export * from "./kw_tab.vue?vue&type=script&lang=js&"
import style0 from "./kw_tab.vue?vue&type=style&index=0&id=2c69d953&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c69d953",
  null
  
)

component.options.__file = "kw_tab.vue"
export default component.exports